import { render } from "./estrattoConto.vue?vue&type=template&id=6a7f722e&ts=true"
import script from "./estrattoConto.vue?vue&type=script&lang=ts"
export * from "./estrattoConto.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__